import { render, staticRenderFns } from "./VIC.vue?vue&type=template&id=12f51982&scoped=true&"
import script from "./VIC.vue?vue&type=script&lang=js&"
export * from "./VIC.vue?vue&type=script&lang=js&"
import style0 from "./VIC.vue?vue&type=style&index=0&id=12f51982&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f51982",
  null
  
)

export default component.exports